// constants/cardTemplates.js - Pre-designed Card Templates

export const CARD_TEMPLATES = [
  {
    id: 'birthday-1',
    name: 'Birthday Celebration',
    category: 'birthday',
    preview: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=400&h=400&fit=crop',
    themeColor: '#FF6B6B',
    envelopeStyle: 'red',
    fontFamily: 'pacifico',
    defaultTitle: 'Happy Birthday!',
    defaultNotes: 'Wishing you a day filled with happiness and celebration!',
  },
  {
    id: 'birthday-2',
    name: 'Birthday Balloons',
    category: 'birthday',
    preview: 'https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=400&h=400&fit=crop',
    themeColor: '#FFD93D',
    envelopeStyle: 'gold',
    fontFamily: 'hanalei',
    defaultTitle: 'Happy Birthday!',
    defaultNotes: 'Hope your special day is as amazing as you are!',
  },
  {
    id: 'thank-you-1',
    name: 'Thank You Flowers',
    category: 'thank-you',
    preview: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=400&h=400&fit=crop',
    themeColor: '#FF69B4',
    envelopeStyle: 'pink',
    fontFamily: 'carattere',
    defaultTitle: 'Thank You',
    defaultNotes: 'Your kindness means the world to me. Thank you!',
  },
  {
    id: 'thank-you-2',
    name: 'Gratitude',
    category: 'thank-you',
    preview: 'https://images.unsplash.com/photo-1518176258769-f227c798150e?w=400&h=400&fit=crop',
    themeColor: '#4ECDC4',
    envelopeStyle: 'blue',
    fontFamily: 'pinyon',
    defaultTitle: 'Thank You',
    defaultNotes: 'I appreciate everything you do!',
  },
  {
    id: 'congrats-1',
    name: 'Congratulations',
    category: 'congratulations',
    preview: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&h=400&fit=crop',
    themeColor: '#FFD700',
    envelopeStyle: 'gold',
    fontFamily: 'pacifico',
    defaultTitle: 'Congratulations!',
    defaultNotes: 'So proud of your achievement! Well done!',
  },
  {
    id: 'congrats-2',
    name: 'Success',
    category: 'congratulations',
    preview: 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?w=400&h=400&fit=crop',
    themeColor: '#7C4DFF',
    envelopeStyle: 'purple',
    fontFamily: 'estonia',
    defaultTitle: 'Congratulations!',
    defaultNotes: 'Your hard work has paid off. Congratulations!',
  },
  {
    id: 'love-1',
    name: 'Love & Romance',
    category: 'love',
    preview: 'https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=400&h=400&fit=crop',
    themeColor: '#FF1493',
    envelopeStyle: 'red',
    fontFamily: 'pinyon',
    defaultTitle: 'Love You',
    defaultNotes: 'You make every moment special. I love you!',
  },
  {
    id: 'love-2',
    name: 'Heart',
    category: 'love',
    preview: 'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&h=400&fit=crop',
    themeColor: '#FF69B4',
    envelopeStyle: 'pink',
    fontFamily: 'carattere',
    defaultTitle: 'Love You',
    defaultNotes: 'Forever grateful to have you in my life.',
  },
  {
    id: 'holiday-1',
    name: 'Holiday Cheer',
    category: 'holiday',
    preview: 'https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=400&h=400&fit=crop',
    themeColor: '#DC143C',
    envelopeStyle: 'red',
    fontFamily: 'hanalei',
    defaultTitle: 'Happy Holidays!',
    defaultNotes: 'Wishing you joy and peace this holiday season!',
  },
  {
    id: 'holiday-2',
    name: 'Winter Wonderland',
    category: 'holiday',
    preview: 'https://images.unsplash.com/photo-1482517967863-00e15c9b44be?w=400&h=400&fit=crop',
    themeColor: '#4169E1',
    envelopeStyle: 'blue',
    fontFamily: 'estonia',
    defaultTitle: 'Season\'s Greetings',
    defaultNotes: 'May your holidays be filled with warmth and happiness!',
  },
  {
    id: 'general-1',
    name: 'Sunset',
    category: 'general',
    preview: 'https://images.unsplash.com/photo-1495616811223-4d98c6e9c869?w=400&h=400&fit=crop',
    themeColor: '#FF6B6B',
    envelopeStyle: 'classic',
    fontFamily: 'default',
    defaultTitle: 'Thinking of You',
    defaultNotes: 'Just wanted to send some positive vibes your way!',
  },
  {
    id: 'general-2',
    name: 'Nature',
    category: 'general',
    preview: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=400&fit=crop',
    themeColor: '#228B22',
    envelopeStyle: 'green',
    fontFamily: 'default',
    defaultTitle: 'Hello!',
    defaultNotes: 'Hope you\'re having a wonderful day!',
  },
];

export const TEMPLATE_CATEGORIES = [
  { id: 'all', name: 'All Templates', icon: '🎨' },
  { id: 'birthday', name: 'Birthday', icon: '🎂' },
  { id: 'thank-you', name: 'Thank You', icon: '🙏' },
  { id: 'congratulations', name: 'Congratulations', icon: '🎉' },
  { id: 'love', name: 'Love', icon: '❤️' },
  { id: 'holiday', name: 'Holiday', icon: '🎄' },
  { id: 'general', name: 'General', icon: '✨' },
];

export const getTemplatesByCategory = (categoryId) => {
  if (categoryId === 'all') return CARD_TEMPLATES;
  return CARD_TEMPLATES.filter(template => template.category === categoryId);
};

export const getTemplateById = (id) => {
  return CARD_TEMPLATES.find(template => template.id === id);
};

export default CARD_TEMPLATES;
